import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { v4 as uuid } from "uuid";

export const Conocimientos = () => {
  const [t] = useTranslation("global");

  const [knowledge, setKnowledge] = useState([
    {
      id: uuid(),

      picture: "https://res.cloudinary.com/devsing/image/upload/v1654288795/Portfolio/noun-ui-2190059_zhxsft.svg",
      nameSkill: "Design",
      content: "ui/ux",
      color: "GreenSocial",
      hide: false,
    },
    {
      id: uuid(),

      picture: "https://res.cloudinary.com/devsing/image/upload/v1654288823/Portfolio/noun-management-3619271_mm4bdw.svg",
      nameSkill: "projectsManagemet",
      content: "gestion",
      color: "BlueSocial",
      hide: true,
    },
    {
      id: uuid(),

      picture: "https://res.cloudinary.com/devsing/image/upload/v1654288824/Portfolio/noun-project-3474313_fpyvrq.svg",
      nameSkill: "arq",
      content: "comp-rec",
      color: "SkySocial",
      hide: false,
    },
    {
      id: uuid(),

      picture: "https://res.cloudinary.com/devsing/image/upload/v1654288825/Portfolio/noun-seo-2499439_jaxdox.svg",
      nameSkill: "SEO",
      content: "seo-des",
      color: "YellowSocial",
      hide: false,
    },
    {
      id: uuid(),

      picture: "https://res.cloudinary.com/devsing/image/upload/v1654288797/Portfolio/noun-ux-3257398_o8ilmc.svg",
      nameSkill: "dev",
      content: "devs",
      color: "orange",
      hide: false,
    },
  ]);

  const handleSelected = (id) => {
    let ItemsCopy = knowledge.map((elem) => {
      if (elem.id === id) {
        elem.hide = true;
      } else {
        elem.hide = false;
      }
      return elem;
    });

    setKnowledge(ItemsCopy);
    // console.log(id);
  };

  return (
    <>
      <br />
      <br />

      <div>
        <h2 className="text-center text-gray-800 font-Montserrat font-bold text-2xl">
          {t("Conocimientos")}
        </h2>

        <div className="grid mobile:grid-cols-1 tablet:grid-cols-2 tabletbig:grid-cols-3 w-96/0 mobile:mx-2 tabletbig:mx-10 justify-between items-center bg-gray-50 transition-all duration-500 ease-in">
          {knowledge.map((item, index) => (
            <div
              className={`
              ${
                item.hide &&
                `bg-${item.color} p-1 rounded-xl m-2 transition-all duration-500 ease-in`
              }
            `}
              key={item.id}
            >
              <div
                className="bg-white ring-2 ring-gray-200 shadow-lg m-5 rounded-2xl p-3 justify-center items-center flex flex-col cursor-pointer transition-all duration-500 ease-in"
                onClick={() => handleSelected(item.id)}
              >
                <div
                  className={`${
                    item.hide &&
                    `rounded-full  bg-${item.color} w-10 h-10 text-center -top-9 relative z-30 flex justify-center items-center transition-all duration-500 ease-in`
                  }`}
                >
                  <p className="text-2xl font-Poppins font-bold text-white">
                    {index + 1}
                  </p>
                </div>
                <img loading='lazy'
                  src={item.picture}
                  alt={t(item.nameSkill)}
                  className="w-20 bg-yellow-400 shadow-2xl rounded-lg p-2 justify-center items-center flex"
                />
                <p className="text-gray-800 font-semibold font-Poppins text-center my-2 text-smt tabletbig:text-1xl">
                  {t(item.nameSkill)}
                </p>

                <p className="text-gray-600 font-medium font-Poppins m-2 text-justify text-smt tabletbig:text-1xl">
                  {t(item.content)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <br />
      <br />
    </>
  );
};
